import { DPFormField, DPInputDropdown } from '@framework'
import { useTranslation } from '@hooks'
import React from 'react'
import { IDropdownOption } from 'model'

export function FuelTypeDropDownComponent() {
    const $t = useTranslation('FuelTypeDropDownComponent')
    
    const options: IDropdownOption<number>[] = [
        {
            key: '1',
            text: $t('Benzin'),
            value: 1
        },
        {
            key: '2',
            text: $t('Diesel'),
            value: 2
        },
        {
            key: '3',
            text: $t('El'),
            value: 3
        },
        {
            key: '5',
            text: $t('Hybrid'),
            value: 5
        }
    ]

    return (
        <DPFormField name="fuelTypeId" label={$t('FuelType')} inline={true}>
            <DPInputDropdown
                name="fuelTypeId"
                options={options}
                search
                clearable
            />
        </DPFormField>
    )
}
